import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { SMS_MODULE_URL } from '@shared/helpers/env';

class MailingListServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params) {
    return super.getList({ ...params });
  }

  getSelect(params) {
    return this.http.get('/select', { params });
  }

  getCost(params = {}) {
    return this.http.post('/calculate', params);
  }
}

export const MailingListService = new MailingListServiceClass({
  api_version: 1,
  resource: 'mailings',
  base_url: SMS_MODULE_URL
});


class ArchiveMailingListServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params) {
    return super.getList({ ...params });
  }

  getSelect(params) {
    return this.http.get('/select', { params });
  }

  getCost(params = {}) {
    return this.http.post('/calculate', params);
  }
}

export const ArchiveMailingListService = new ArchiveMailingListServiceClass({
  api_version: 2,
  resource: 'mailings'
});
